import { useState, useCallback } from "react";
import * as Constants from "../components/Constants.js";

const usePatchURL = () => {
  const [isGrabando, setGrabando] = useState(false);
  const [erroresPatch, setErroresPatch] = useState(null);

  const patchData = useCallback(async (path, datos, datosGrabados) => {
    setGrabando(true);
    setErroresPatch(null);

    try {
      const response = await fetch(Constants.URLBASE + "/" + path, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datos),
        redirect: "follow",
        credentials: "include",
      });

      if (response.status === 401) {
        document.location.href = "/nosession";
      } else if (response.redirected) {
        document.location = response.url;
      } else if (!response.ok) {
        const json = await response.json();
        setErroresPatch(json.errors ?? json.errores ?? ["Error al actualizar los datos"]);
      } else {
        const env = await response.json().catch(() => null);
        if (env && (env.ok === true || env.ok === false || 'data' in env || 'errors' in env || 'errores' in env)) {
          if (env.ok) {
            datosGrabados(env.data ?? null);
          } else {
            setErroresPatch(env.errors ?? env.errores ?? ["Error al actualizar los datos"]);
          }
        } else {
          datosGrabados();
        }
      }
    } catch (err) {
      console.error("Error Patch", err.message);
      setErroresPatch(["Error al actualizar los datos"]);
    }
    setGrabando(false);
  }, []);

  const resetErroresPatch = useCallback(() => {
    setErroresPatch(null);
  }, []);

  return {isGrabando, erroresPatch, patchData, resetErroresPatch};
};

export default usePatchURL;
